<template>
  <div>
    <van-popup @close="close" v-model="show" get-container="#app">
      <div class="Modal">
        <div class="title">
          <span>{{ title }}</span>
          <span v-if="isClose" @click="determine('isClose')"
            ><van-icon name="cross"
          /></span>
        </div>
        <div class="classCapacity">
          <slot></slot>
        </div>
        <div class="determine">
          <button class="determineLeft" @click="determine()" :disabled="this.$attrs.canClick">
            {{ btnText }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>

export default {
  name: 'SeftPopup',
  data() {
    return {
      show: false,
    };
  },
  props: {
    value: Boolean,
    isClose: Boolean,
    imgUrl: String,
    title: String,
    btnText: String,
  },
  watch: {
    value: {
      handler(val) {
        this.show = val;
      },
      immediate: true,
    },
    show: {
      handler(val) {
        if (!val) {
          this.$emit('input', false);
        }
      },
      immediate: true,
    },
  },
  methods: {
    determine(val) {
      if (val === 'isClose') {
        this.show = false;
        this.$emit('close');
        return;
      }
      // this.show = false;

      if (this.$listeners.define !== undefined) {
        this.$emit('define', {
          // cb: () => {
          //   this.show = false;
          // },
          value: this.value,
        });
      }
    },
    close() {
      this.$emit('close');
      this.show = false;
    },
  },
};
</script>
<style scoped>
.Modal {
  min-height: 226px;
  background: #fff;
  border-radius: 12px;
}
.determine {
  display: flex;
  width: 100%;
  height: 56px;
  color: #f65249;
  font-weight: 700;
  font-size: 13px;
  line-height: 56px;
  border-top: 1px solid #ebf1f5;
}
.determine div {
  flex: 1;
}
.title {
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: rgba(80, 80, 80, 1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #ebf1f5;
}
.classCapacity {
  min-height: 60px;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.inputPic {
  border: 0;
  width: 50%;
}
.van-popup {
  width: 85%;
  border-radius: 12px !important;
}
.determineLeft {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  font-weight: 100;
  letter-spacing: 0;
  height: 44px;
  margin: 16px 16px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #ff6538;
  outline: none;
  border:none;
  width:100%;
}
.determineLeft[disabled] {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  font-weight: 100;
  letter-spacing: 0;
  height: 44px;
  margin: 16px 16px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #9EA7B4;
  outline: none;
  border:none;
  width:100%;
}

.imgCode {
  flex: 1;
  height: 40px;
  background: #fafafa;
}
.imgCode img {
  width: 100%;
  height: 100%;
}
</style>
